(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motion = () => !reduced && !document.body.classList.contains('motion-off');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: document.body.dataset.currency || 'USD' }).format(cents / 100);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* announcement rotator */
  function initAnnounce() {
    $$('[data-announce]').forEach(t => {
      if (t.dataset.bound) return; t.dataset.bound = 1;
      const msgs = $$('.announce__msg', t); if (msgs.length < 2) return;
      let i = 0; const ms = (+t.dataset.speed || 4) * 1000;
      setInterval(() => {
        const cur = msgs[i]; cur.classList.remove('is-active'); cur.classList.add('is-out');
        setTimeout(() => cur.classList.remove('is-out'), 500);
        i = (i + 1) % msgs.length; msgs[i].classList.add('is-active');
      }, ms);
    });
  }

  /* header: dropdowns, mobile nav, search, scroll */
  function initHeader() {
    const header = $('[data-header]');
    $$('[data-drop-toggle]').forEach(btn => {
      if (btn.dataset.bound) return; btn.dataset.bound = 1;
      const item = btn.closest('.hdr__item');
      const set = open => { $$('.hdr__item.is-open').forEach(o => { if (o !== item) { o.classList.remove('is-open'); $('[data-drop-toggle]', o).setAttribute('aria-expanded', 'false'); } }); item.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open)); };
      btn.addEventListener('click', () => set(!item.classList.contains('is-open')));
      item.addEventListener('mouseenter', () => matchMedia('(hover:hover)').matches && set(true));
      item.addEventListener('mouseleave', () => matchMedia('(hover:hover)').matches && set(false));
    });
    document.addEventListener('click', e => { if (!e.target.closest('.hdr__item')) $$('.hdr__item.is-open').forEach(o => { o.classList.remove('is-open'); $('[data-drop-toggle]', o)?.setAttribute('aria-expanded', 'false'); }); });
    const mnav = $('[data-mobile-nav]'), burger = $('[data-menu-toggle]');
    const setNav = open => { if (!mnav) return; mnav.hidden = !open; burger?.setAttribute('aria-expanded', String(open)); document.documentElement.style.overflow = open ? 'hidden' : ''; if (open) $('[data-menu-close]', mnav)?.focus(); };
    burger?.addEventListener('click', () => setNav(true));
    mnav?.addEventListener('click', e => { if (e.target === mnav || e.target.closest('[data-menu-close]')) setNav(false); });
    const panel = $('[data-search-panel]');
    $('[data-search-open]')?.addEventListener('click', e => { if (!panel) return; e.preventDefault(); panel.hidden = !panel.hidden; if (!panel.hidden) $('input[type=search]', panel).focus(); });
    $('[data-search-close]')?.addEventListener('click', () => { panel.hidden = true; });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { setNav(false); if (panel) panel.hidden = true; closeDrawer(); $$('.hdr__item.is-open').forEach(o => o.classList.remove('is-open')); } });
    const bar = $('[data-scroll-progress]'); let ticking = false;
    const onScroll = () => { header?.classList.toggle('is-scrolled', scrollY > 40); const h = document.documentElement.scrollHeight - innerHeight; bar?.style.setProperty('--p', h > 0 ? Math.min(1, scrollY / h) : 0); ticking = false; };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true }); onScroll();
  }

  /* reveal on scroll */
  function initReveal(scope = document) {
    if (!motion() || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: .12, rootMargin: '0px 0px -40px' });
    $$('.sec__head,.card,.tile,.trust__item,.story__copy,.story__media,.spot__info,.spot__media', scope).forEach((el, i) => {
      if (el.dataset.rv) return; el.dataset.rv = 1;
      const r = el.getBoundingClientRect(); if (r.top < innerHeight) return;
      el.classList.add('js-reveal'); el.style.transitionDelay = `${(i % 4) * 70}ms`; io.observe(el);
    });
  }

  /* rails */
  function initRails(scope = document) {
    $$('.rail--scroll', scope).forEach(sec => {
      const rail = $('[data-rail]', sec); if (!rail || sec.dataset.bound) return; sec.dataset.bound = 1;
      const step = () => (rail.querySelector('.card')?.offsetWidth || 300) + 20;
      $('[data-rail-prev]', sec)?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      $('[data-rail-next]', sec)?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  }

  /* variant picker */
  function initBuy(scope = document) {
    $$('[data-buy]', scope).forEach(wrap => {
      if (wrap.dataset.bound) return; wrap.dataset.bound = 1;
      const form = $('form', wrap), json = $('[data-variants]', wrap); if (!json) return;
      const variants = JSON.parse(json.textContent);
      const idInput = $('[data-variant-id]', wrap), add = $('[data-add]', wrap);
      const scopeEl = wrap.closest('[data-pdp]') || wrap.closest('.spot') || document;
      const sync = () => {
        const chosen = $$('fieldset[data-opt]', wrap).map(fs => $('input:checked', fs)?.value);
        const v = chosen.length ? variants.find(x => x.options.every((o, i) => o === chosen[i])) : variants[0];
        $$('fieldset[data-opt]', wrap).forEach((fs, idx) => {
          const lab = $('[data-opt-value]', fs); if (lab) lab.textContent = chosen[idx] || '';
          $$('input', fs).forEach(inp => {
            const test = chosen.slice(); test[idx] = inp.value;
            const match = variants.find(x => x.options.every((o, i) => o === test[i]));
            inp.closest('.pill').classList.toggle('is-unavailable', !match || !match.available);
          });
        });
        if (!v) { add.disabled = true; add.textContent = 'UNAVAILABLE'; return; }
        idInput.value = v.id; add.disabled = !v.available; add.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
        $$('[data-price]', scopeEl).forEach(p => { p.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ` <s>${money(v.compare_at_price)}</s>` : ''); });
        if (v.featured_media && scopeEl !== document) showMedia(scopeEl, v.featured_media.id);
        if (wrap.closest('[data-pdp]') && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
      };
      wrap.addEventListener('change', e => { if (e.target.matches('[data-opt-input]')) sync(); });
      $$('[data-qty]', wrap).forEach(b => b.addEventListener('click', () => { const q = $('input[name=quantity]', wrap); q.value = Math.max(1, (+q.value || 1) + (+b.dataset.qty)); }));
      form.addEventListener('submit', e => { if (document.body.dataset.cartType === 'page') return; e.preventDefault(); addToCart(new FormData(form), add); });
      $('[data-size-guide]', wrap)?.addEventListener('click', () => $('[data-size-modal]')?.showModal());
      sync();
    });
    $$('[data-modal-close]').forEach(b => b.addEventListener('click', () => b.closest('dialog').close()));
  }

  function showMedia(scope, id) {
    const slides = $$('[data-media-id]', scope); if (!slides.length) return;
    slides.forEach(s => s.classList.toggle('is-active', s.dataset.mediaId == id));
    $$('[data-thumb]', scope).forEach(t => t.classList.toggle('is-active', t.dataset.thumb == id));
  }

  function initGallery() {
    $$('[data-pdp]').forEach(pdp => {
      if (pdp.dataset.gbound) return; pdp.dataset.gbound = 1;
      $$('[data-thumb]', pdp).forEach(t => t.addEventListener('click', () => showMedia(pdp, t.dataset.thumb)));
      const main = $('.pdp__main', pdp); let x0 = null;
      main?.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      main?.addEventListener('touchend', e => {
        if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) < 40) return;
        const slides = $$('[data-media-id]', pdp); const i = slides.findIndex(s => s.classList.contains('is-active'));
        const n = slides[(i + (dx < 0 ? 1 : -1) + slides.length) % slides.length]; showMedia(pdp, n.dataset.mediaId);
      });
      const sticky = $('[data-sticky-buy]', pdp), addBtn = $('[data-add]', pdp);
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        sticky.hidden = false;
        new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
        $('[data-sticky-add]', sticky).addEventListener('click', () => { addBtn.scrollIntoView({ behavior: motion() ? 'smooth' : 'auto', block: 'center' }); if (!addBtn.disabled) addBtn.click(); });
      }
    });
  }

  /* quick add */
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-quick-add]'); if (!f || document.body.dataset.cartType === 'page') return;
    e.preventDefault(); addToCart(new FormData(f), f.querySelector('button'));
  });

  /* cart */
  const drawer = () => $('[data-cart-drawer]');
  let lastFocus = null;
  function openDrawer() { const d = drawer(); if (!d) return; lastFocus = document.activeElement; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; setTimeout(() => $('.drawer__panel', d).focus(), 50); }
  function closeDrawer() { const d = drawer(); if (!d || !d.classList.contains('is-open')) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; lastFocus?.focus?.(); }
  function toast(msg) { const t = $('[data-toast]'); if (!t) return; t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-on'), 2600); }

  async function addToCart(fd, btn) {
    const label = btn?.textContent; if (btn) { btn.disabled = true; btn.classList.add('is-loading'); if (btn.matches('[data-add]')) btn.textContent = 'ADDING…'; }
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      await renderCart();
      if (document.body.dataset.cartType === 'drawer') openDrawer(); else toast(`Added ${data.product_title || 'item'} to cart`);
    } catch (err) { toast(err.message); }
    finally { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); if (btn.matches('[data-add]')) btn.textContent = label; } }
  }

  async function renderCart() {
    const d = drawer();
    const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    $$('[data-cart-count]').forEach(c => { c.textContent = cart.item_count; c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); });
    $$('.hdr__cart').forEach(a => a.setAttribute('aria-label', `Cart, ${cart.item_count} items`));
    if (!d) return cart;
    $('[data-cart-subtotal]', d).textContent = money(cart.total_price);
    const body = $('[data-cart-items]', d);
    body.innerHTML = cart.items.length ? cart.items.map((it, i) => `
      <div class="ditem">
        <a href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image + (it.image.includes('?') ? '&' : '?') + 'width=200')}" alt="" loading="lazy" width="80" height="100">` : ''}</a>
        <div><h3><a href="${esc(it.url)}">${esc(it.product_title)}</a></h3>${it.product_has_only_default_variant ? '' : `<p>${esc(it.variant_title)}</p>`}
          <div class="qty"><button type="button" data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="Decrease">−</button><input type="number" value="${it.quantity}" min="0" data-line-input="${i + 1}" aria-label="Quantity"><button type="button" data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="Increase">+</button></div>
        </div>
        <div class="ditem__price">${money(it.final_line_price)}<button type="button" class="ditem__rm" data-line="${i + 1}" data-q="0">Remove</button></div>
      </div>`).join('') : `<div class="drawer__empty"><p class="h2" style="font-size:40px">YOUR CART IS <em>EMPTY.</em></p><a class="btn" href="${root}collections/all">SHOP EVERYTHING</a></div>`;
    $('.drawer__foot', d).style.display = cart.items.length ? '' : 'none';
    const ship = $('[data-ship-bar]', d);
    if (ship) { const th = +ship.dataset.threshold; const left = th - cart.total_price; $('[data-ship-text]', ship).textContent = left > 0 ? `You’re ${money(left)} away from free shipping` : 'You unlocked free shipping'; $('[data-ship-fill]', ship).style.width = `${Math.min(100, cart.total_price / th * 100)}%`; }
    return cart;
  }

  async function changeLine(line, quantity) {
    const d = drawer(); d?.classList.add('is-loading');
    try { await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +line, quantity: Math.max(0, +quantity) }) }); await renderCart(); }
    catch (e) { toast('Could not update cart'); } finally { d?.classList.remove('is-loading'); }
  }

  document.addEventListener('click', e => {
    const open = e.target.closest('[data-cart-open]');
    if (open && document.body.dataset.cartType === 'drawer' && !document.body.classList.contains('template-cart')) { e.preventDefault(); renderCart(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    const l = e.target.closest('[data-line]'); if (l) changeLine(l.dataset.line, l.dataset.q);
  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-line-input]')) changeLine(e.target.dataset.lineInput, e.target.value);
    if (e.target.matches('[data-filter-input]')) {
      const form = e.target.closest('form'); const params = new URLSearchParams(new FormData(form));
      [...params.keys()].forEach(k => { if (params.get(k) === '') params.delete(k); });
      location.search = params.toString();
    }
  });
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-filter-form]'); if (!form) return;
    e.preventDefault(); const params = new URLSearchParams(new FormData(form));
    [...params.keys()].forEach(k => { if (params.get(k) === '') params.delete(k); }); location.search = params.toString();
  });

  /* related products */
  function initRelated() {
    $$('[data-related]').forEach(async el => {
      if (el.dataset.bound || el.children.length) return; el.dataset.bound = 1;
      try { const html = await (await fetch(el.dataset.url)).text(); const tmp = document.createElement('div'); tmp.innerHTML = html; const inner = tmp.querySelector('[data-related]'); if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; initRails(el.parentElement); initReveal(el); } } catch (e) {}
    });
  }

  const init = (scope = document) => { initAnnounce(); initBuy(scope); initGallery(); initRails(scope); initReveal(scope); };
  const start = () => { initHeader(); init(); initRelated(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
